var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-text-center"},[_c('scale-loader',{attrs:{"loading":true,"color":'#ff8678',"height":'70px',"width":'5px'}}),_c('h3',[_vm._v(_vm._s(_vm.loadingMessage))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }